import { useRootStore } from '@hooks/useRootStore';
import { Alert, Snackbar, Typography } from '@mui/material';
import { observer } from "mobx-react-lite";

interface ToastProps {

}

const Toast = observer((props: ToastProps) => {
    const { toastStore } = useRootStore();
    const { toastModel, onClose } = toastStore;

    const { title, subtitle, type, isOpen, autoHideDuration } = toastModel
    return (
        <Snackbar
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "center"
            }}
            open={isOpen}
            autoHideDuration={autoHideDuration}
            onClose={onClose}>
            <Alert onClose={onClose} severity={type} sx={{ width: '100%' }}>
                <Typography fontWeight={600}>{title}</Typography>
                <Typography color={"CaptionText"}>{subtitle}</Typography>
            </Alert>
        </Snackbar>
    );
});

export default Toast;
